import React, { useEffect, useRef } from "react";

declare global {
  interface Window {
    IN?: { parse: (el?: Element | null) => void };
    __liFollowReady?: () => void;
  }
}

const SENSWISE_COMPANY_ID = "83026167";

const LinkedInFollowButton: React.FC = () => {
  const containerRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const insertPlugin = () => {
      container.innerHTML = "";
      const s = document.createElement("script");
      s.type = "IN/FollowCompany";
      s.setAttribute("data-id", SENSWISE_COMPANY_ID);
      s.setAttribute("data-counter", "right");
      container.appendChild(s);
      window.IN?.parse(container);
    };

    if (window.IN) {
      insertPlugin();
      return;
    }

    if (!document.getElementById("li-platform-sdk")) {
      window.__liFollowReady = insertPlugin;

      const sdk = document.createElement("script");
      sdk.id = "li-platform-sdk";
      sdk.type = "text/javascript";
      sdk.src = "https://platform.linkedin.com/in.js";
      sdk.text = "lang: en_US\nonLoad: window.__liFollowReady && window.__liFollowReady()";
      document.head.appendChild(sdk);
    } else {
      const timer = setInterval(() => {
        if (window.IN) {
          clearInterval(timer);
          insertPlugin();
        }
      }, 150);
      return () => clearInterval(timer);
    }
  }, []);

  return <span ref={containerRef} className="inline-flex items-center" />;
};

export default LinkedInFollowButton;
